import { Http } from '@/lib/http';

export class PrimaryAccountClassesService extends Http {
    constructor() {
      super();
      
      this.endpoint = 'gl/settings/primary-account-classes';
    }

    create(payload) {
      return this.httpClient().post(`${this.endpoint}`, payload);
    }
  
    findAll() {
      return this.httpClient().get(`${this.endpoint}`);
    }
  
    update(id, payload) {
      return this.httpClient().put(`${this.endpoint}/${id}`, payload);
    }
  
    delete(id) {
      return this.httpClient().delete(`${this.endpoint}/${id}`);
    }
  }